// Code generated by protoc-gen-weave-ts. DO NOT EDIT.
import * as fm from "../../../../fetch.pb.js";
export var Processor;
(function (Processor) {
    Processor["PROCESSOR_UNSPECIFIED"] = "PROCESSOR_UNSPECIFIED";
    Processor["STRIPE"] = "STRIPE";
    Processor["JUSTIFI"] = "JUSTIFI";
})(Processor || (Processor = {}));
export var Processor_index;
(function (Processor_index) {
    Processor_index[Processor_index["PROCESSOR_UNSPECIFIED"] = 0] = "PROCESSOR_UNSPECIFIED";
    Processor_index[Processor_index["STRIPE"] = 1] = "STRIPE";
    Processor_index[Processor_index["JUSTIFI"] = 2] = "JUSTIFI";
})(Processor_index || (Processor_index = {}));
export var StripePayoutSummaryItemType;
(function (StripePayoutSummaryItemType) {
    StripePayoutSummaryItemType["PAYOUT_SUMMARY_ITEM_TYPE_UNSPECIFIED"] = "PAYOUT_SUMMARY_ITEM_TYPE_UNSPECIFIED";
    StripePayoutSummaryItemType["PAYOUT_SUMMARY_ITEM_TYPE_CHARGES"] = "PAYOUT_SUMMARY_ITEM_TYPE_CHARGES";
    StripePayoutSummaryItemType["PAYOUT_SUMMARY_ITEM_TYPE_APPLICATION_FEE"] = "PAYOUT_SUMMARY_ITEM_TYPE_APPLICATION_FEE";
    StripePayoutSummaryItemType["PAYOUT_SUMMARY_ITEM_TYPE_REFUNDS"] = "PAYOUT_SUMMARY_ITEM_TYPE_REFUNDS";
    StripePayoutSummaryItemType["PAYOUT_SUMMARY_ITEM_TYPE_ADJUSTMENTS"] = "PAYOUT_SUMMARY_ITEM_TYPE_ADJUSTMENTS";
})(StripePayoutSummaryItemType || (StripePayoutSummaryItemType = {}));
export var StripePayoutSummaryItemType_index;
(function (StripePayoutSummaryItemType_index) {
    StripePayoutSummaryItemType_index[StripePayoutSummaryItemType_index["PAYOUT_SUMMARY_ITEM_TYPE_UNSPECIFIED"] = 0] = "PAYOUT_SUMMARY_ITEM_TYPE_UNSPECIFIED";
    StripePayoutSummaryItemType_index[StripePayoutSummaryItemType_index["PAYOUT_SUMMARY_ITEM_TYPE_CHARGES"] = 1] = "PAYOUT_SUMMARY_ITEM_TYPE_CHARGES";
    StripePayoutSummaryItemType_index[StripePayoutSummaryItemType_index["PAYOUT_SUMMARY_ITEM_TYPE_APPLICATION_FEE"] = 2] = "PAYOUT_SUMMARY_ITEM_TYPE_APPLICATION_FEE";
    StripePayoutSummaryItemType_index[StripePayoutSummaryItemType_index["PAYOUT_SUMMARY_ITEM_TYPE_REFUNDS"] = 3] = "PAYOUT_SUMMARY_ITEM_TYPE_REFUNDS";
    StripePayoutSummaryItemType_index[StripePayoutSummaryItemType_index["PAYOUT_SUMMARY_ITEM_TYPE_ADJUSTMENTS"] = 4] = "PAYOUT_SUMMARY_ITEM_TYPE_ADJUSTMENTS";
})(StripePayoutSummaryItemType_index || (StripePayoutSummaryItemType_index = {}));
/**
 * PayoutsAPI Handles the gRPC endpoints related to the payouts.
 * The endpoints are implemented in the payouts service.
 */
export const PayoutsAPI = {
    ListPayouts(fn, req) {
        return fn(`/payments-platform/payouts/v1/payouts`, { method: "POST", body: JSON.stringify(req, fm.replacer) });
    },
    GetLocationPayout(fn, req) {
        try {
            fm.validateUrlParam(req["locationId"], "locationId");
            fm.validateUrlParam(req["payoutId"], "payoutId");
        }
        catch (e) {
            return Promise.reject(e);
        }
        return fn(`/payments-platform/payouts/v1/${req["locationId"]}/${req["payoutId"]}?${fm.renderURLSearchParams(req, ["locationId", "payoutId"])}`, { method: "GET" });
    },
    ListLocationPayoutTransactions(fn, req) {
        try {
            fm.validateUrlParam(req["locationId"], "locationId");
            fm.validateUrlParam(req["payoutId"], "payoutId");
        }
        catch (e) {
            return Promise.reject(e);
        }
        return fn(`/payments-platform/payouts/v1/${req["locationId"]}/${req["payoutId"]}/transactions?${fm.renderURLSearchParams(req, ["locationId", "payoutId"])}`, { method: "GET" });
    },
    GetPayoutsSummary(fn, req) {
        return fn(`/payments-platform/payouts/v1/summary`, { method: "POST", body: JSON.stringify(req, fm.replacer) });
    },
};
